<template>
  <div>
    <h4 class="text-center purple">{{$t('marketingCampaigns.chooseTarget')}}</h4>
    <div class="row">
      <div class="col-md-10 col-md-offset-1 pad-bt-15">
        <form>
          <div class="row">
            <div :class="colsClass + ' col-sm-6 col-xs-12 form-group'">
              <label class="control-label text-purple">{{$t('marketingCampaigns.gender')}}</label>
              <select v-model="filters[1].value"
                      :placeholder="$t('marketingCampaigns.gender')"
                      class="form-control">
                <option selected=""  value=""> - {{$t('general.all')}} - </option>  
                <option value="M">{{$t('gender.male')}}</option>        
                <option value="F">{{$t('gender.female')}}</option>
              </select>
            </div>
            <div :class="colsClass + ' col-sm-6 col-xs-12 form-group'">
              <label class="control-label text-purple">{{$t('marketingCampaigns.age')}}</label>
              <br>
              <select 
                      name="age"
                      :placeholder="$t('marketingCampaigns.age')"
                      class="form-control"
                      v-model="filters[3].value">
                <option selected=""  value=""> - {{$t('general.all')}} - </option>  
                <option value="20">{{$t('reportsAgesGroups.20')}}</option>
                <option value="20-30">{{$t('reportsAgesGroups["20-30"]')}}</option>
                <option value="30-40">{{$t('reportsAgesGroups["30-40"]')}}</option>
                <option value="40-50">{{$t('reportsAgesGroups["40-50"]')}}</option>
                <option value="50+">{{$t('reportsAgesGroups["50"]')}}</option>    
              </select>
            </div>
            <div class="col-md-3 col-sm-6 col-xs-12 form-group" v-if="locations.length > 1">
              <label class="control-label text-purple">{{$t('marketingCampaigns.location')}}</label>
              <!-- <input type="text"  name="location_id" placeholder="" class="form-control" v-model="filters[4].value"> -->
              <select 
                      name="location_id"
                      placeholder=""
                      class="form-control"
                      v-model="filters[4].value">
                <option selected=""  value=""> - {{$t('general.all')}} - </option>  
                <option v-for="loc in locations" :value="loc.id">{{loc.name}}</option>   
              </select>
            </div>
            <div :class="colsClass + ' col-sm-6 col-xs-12 form-group'">
              <!-- -->
              <label class="control-label text-purple">{{$t('marketingCampaigns.ordersAbove')}} ({{currency}})</label>
              <input type="number"  placeholder="E.g. 200" class="form-control" v-model="filters[2].value" >
            </div>
         
   <!--          <div class="col-md-12 form-group">
              <label class=""></label>
              <button @click.prevent="filterCustomers()" type="submit" class="btn btn-fill btn-info">
                Filter
              </button> 
              <button @click="resetTable()" type="reset" class="btn btn-info">
                Reset
              </button> 
              <span v-if="customerList > 0">
                &nbsp;&nbsp;{{customerList }} customers found
              </span>
            </div> -->
          </div>
        </form>
      </div>
    </div>
    <data-tables class=""
                      :data="tableData" 
                      :filters="filters"
                      :table-props="{'border': false, 'stripe': false,}"
                      style="width: 100%; background: #fff"
                      @filtered-data="dataFiltered"
                      >
              <el-table-column
                label=""
                :min-width="80">
                <template slot-scope="props">
                  <template v-if="props.row.firstname != null || props.row.lastname != null">
                    {{ props.row.firstname}} {{ props.row.lastname}}
                  </template>
                  <template v-else>
                    {{ props.row.email}}
                  </template>
                </template>
              </el-table-column>
              <el-table-column
                label=""
                :min-width="60">
                <template slot-scope="props">
                  <b>{{ props.row.sales > 0 ? formatMoneyAmount(props.row.sales, props.row.currency) : '' }}</b>
                </template>
              </el-table-column>
            </data-tables>
  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'

  export default {
    props: {
      modelFromParent: {
        type: [Object, Array],
        required: true
      },
      daysParent: {
        type: Array,
        required: true
      }
    },
    watch: {
      modelFromParent (value, oldVal) {
        this.model = value
        this.filters[1].value = value.user_filters ? value.user_filters.gender : null
        this.filters[2].value = value.user_filters ? value.user_filters.orders_above : null
        this.filters[3].value = value.user_filters ? value.user_filters.age : null
        this.filters[4].value = value.user_filters ? value.user_filters.location_id : null
        this.counter_matching_users = value.user_filters && value.user_filters.counter_matching_users ? value.user_filters.counter_matching_users : this.counter_matching_users
        this.model.counter_matching_users = this.counter_matching_users
      },
      daysParent (value, oldVal) {
        this.days = value
      }
    },
    computed: {
      ...mapFields(['notification_type', 'notification_mode', 'email'])
    },
    created: function () {
      var self = this
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.apiRequest('/customer', 'GET', data, function (response) {
        if (response.status === true) {
          // for (let customerIdx in response.data) {
          //   let addrs = ''
          //   for (let address of response.data[customerIdx].addresses) {
          //     addrs = addrs + ' ' + address.city
          //   }
          //   response.data[customerIdx].cities = addrs
          // }
          // console.warn(response.data)
          self.tableData = response.data
          self.counter_matching_users = response.data.length
        }
      })

      let company = this.$session.get('selectedCompanyData')
      this.locations = company.locations_details
      if (this.locations.length > 1) {
        this.colsClass = 'col-md-3'
      }
      this.currency = this.getCurrencySymbol(company.currency_iso)
    },
    data () {
      return {
        tableData: [],
        model: this.value || this.modelFromParent,
        days: this.value || this.daysParent,
        modelValidations: {
          notification_type: {
            required: true
          },
          notification_mode: {
            required: true
          },
          email: {
            required: true,
            email: true
          }
        },
        pickerOptions: {
          start: '00:00',
          step: '00:15',
          end: '23:59'
        },
        locations: [],
        colsClass: 'col-md-4',
        campaignsNotificationTypes: this.$session.get('defaultData')['campaigns_notification_types'],
        campaignsModes: this.$session.get('defaultData')['campaigns_modes'],
        filters: [
          {
            value: '',
            prop: ['firstname', 'lastname', 'sales']
          },
          {
            value: '',
            prop: ['gender']
          },
          {
            value: '',
            prop: ['sales'],
            filterFn: (row, filter) => {
              return row.sales > filter.value
            }
          },
          {
            value: '',
            prop: ['birthdate'],
            filterFn: (row, filter) => {
              var age = this.getAge(row.birthdate)
              switch (filter.value) {
                case '20':
                  if (age < 20) {
                    return row
                  }
                  break
                case '20-30':
                  if (age >= 20 && age <= 30) {
                    return row
                  }
                  break
                case '30-40':
                  if (age >= 30 && age <= 40) {
                    return row
                  }
                  break
                case '40-50':
                  if (age >= 40 && age <= 50) {
                    return row
                  }
                  break
                case '50+':
                  if (age > 50) {
                    return row
                  }
                  break
              }
              return false
            }
          },
          {
            value: '',
            prop: ['orders_locations'],
            filterFn: (row, filter) => {
              if (row.orders_locations.includes(filter.value)) {
                return true
              }
              return false
            }
          }
        ],
        counter_matching_users: 0,
        currency: ''
      }
    },
    methods: {
      dataFiltered (data) {
        this.counter_matching_users = data.length
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.model.user_filters = {
          gender: this.filters[1].value,
          orders_above: this.filters[2].value,
          age: this.filters[3].value,
          location_id: this.filters[4].value
        }
        return this.$validator.validateAll()
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Campaigns/Steps/ThirdStep.vue